import type { RfxQuestionType } from "../types/returnable-schedule-question.type";
import {
	HAS_ACCEPTED,
	HAS_SUBMITTED,
	QUESTION_TYPE_ID,
	RFX_SUBMISSION_STATUS,
} from "./constants";
import { generateSaveSubmissionPayload } from "./data-processor";
import {
	acceptDeclineSubmission,
	getAllSubmissions,
	getCompanySubmission,
	getGuestRfxInvitation,
	revokeSubmission,
	saveSubmission,
	submitSubmission,
} from "./submission-api";
import { getTextLengthValue, isSmartField } from "./submission-helpers";
import type { GuestCompanyData } from "./types/guest-company-data.type";
import { ReturnableScheduleFileUpload } from "./types/returnable-schedule-answer.type";
import type { RfxSubmissionStatus } from "./types/submission.type";
import {
	approveRevisionRequest,
	declineRevisionRequest,
	getPendingRevisionRequest,
	getQuoteRevisions,
	requestRevision,
	saveQuoteRevision,
	submitRevision,
} from "./api/revision-api";
import type {
	ApproveRevisionPayload,
	DeclineRevisionPayload,
	QuoteAnswerData,
	QuoteRevisionSnapshot,
	RequestRevisionPayload,
	RevisionRequest,
	SaveQuoteRevisionPayload,
} from "./types/revision.type";
import { useRevisionNotifications } from "./hooks/useRevisionNotifications";

const submissionApi = {
	acceptDeclineSubmission,
	getAllSubmissions,
	getCompanySubmission,
	getGuestRfxInvitation,
	revokeSubmission,
	saveSubmission,
	submitSubmission,
};

const revisionApi = {
	approveRevisionRequest,
	declineRevisionRequest,
	getPendingRevisionRequest,
	getQuoteRevisions,
	requestRevision,
	saveQuoteRevision,
	submitRevision,
};

export type {
	GuestCompanyData,
	RfxQuestionType,
	RfxSubmissionStatus,
	ApproveRevisionPayload,
	DeclineRevisionPayload,
	QuoteAnswerData,
	QuoteRevisionSnapshot,
	RequestRevisionPayload,
	RevisionRequest,
	SaveQuoteRevisionPayload,
};

// this is a class type
export { ReturnableScheduleFileUpload };

export { useRevisionNotifications };

export const rfxSubmission = {
	api: submissionApi,
	revisionApi,
	constants: {
		HAS_ACCEPTED,
		HAS_SUBMITTED,
		QUESTION_TYPE: QUESTION_TYPE_ID,
		RFX_SUBMISSION_STATUS,
	},
	helpers: {
		getTextLengthValue,
		isSmartField,
	},
	generateSaveSubmissionPayload,
};
